import React, { useEffect, useState, useRef } from "react";
import './tv.css';
import Logo from '../../../assets/images/logo_orange.png';

const TvSlideShow = () => {
    const [slides, setSlides] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const timeoutRef = useRef(null);

    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const response = await fetch('https://www.autoservicethomas.be/api/slides/');
                const data = await response.json();
                setSlides(data.sort((a, b) => a.order - b.order)); // Optioneel sorteren
            } catch (err) {
                console.error("Fout bij laden slides:", err);
            }
        };
        fetchSlides();
    }, []);

    useEffect(() => {
        if (slides.length === 0) return;

        // Clear oude timer
        if (timeoutRef.current) clearTimeout(timeoutRef.current);

        // Zet timer om naar volgende slide te gaan na slide.duration seconden
        const durationMs = (slides[currentIndex].duration || 5) * 1000; // fallback 5s
        timeoutRef.current = setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
        }, durationMs);

        return () => {
            if (timeoutRef.current) clearTimeout(timeoutRef.current);
        };
    }, [currentIndex, slides]);

    if (slides.length === 0) {
        return <div className="outer-div">Laden...</div>;
    }

    const currentSlide = slides[currentIndex];

    return (
        <div className="outer-div">
            <div className="image-div">
                {currentSlide.imageUrl && (
                    <img
                        key={currentSlide._id}
                        src={`https://autoservicethomas.be/${currentSlide.imageUrl}`}
                        alt={currentSlide.title || "Slide image"}
                        className="slide-image"
                    />

                )}
                {currentSlide.title && (
                <div className="text-div">
                    <div className="logo">
                        <img src={Logo} alt="Auto-Service Thomas logo" />
                    </div>
                    <h2>{currentSlide.title}</h2>
                </div>
            )}
            </div>
        </div>
    );
};

export default TvSlideShow;
